/**
 * Auto-generated from dark-roast DAOs (com.axiom.db.models.dao).
 * Shared by all Java backends — do not edit manually.
 * Regenerate with: yarn sync-entities
 */

import { Entity } from '@data-client/rest';
import { CandidateStatus } from '../enums/candidate-status';
import { CalendarManualInterviewRequestEntity } from './calendar-manual-interview-request-entity';
import { CandidateEntity } from './candidate-entity';
import { OpportunityEntity } from './opportunity-entity';
import { UserEntity } from './user-entity';
export class ClientRequestEntity extends Entity {
  calendarManualInterviewRequests: CalendarManualInterviewRequestEntity[] = [];
  candidate: CandidateEntity | null = null;
  candidateId: string | null = null;
  candidateOpportunityStatus: CandidateStatus | null = null;
  createdAt: string | null = null;
  id: string = '';
  notes: string | null = null;
  opportunity: OpportunityEntity | null = null;
  opportunityId: string | null = null;
  rejectionLossCodes: string[] | null = null;
  updatedAt: string | null = null;
  user: UserEntity | null = null;
  userId: string | null = null;
  static override key = 'ClientRequest';
  static override get schema() {
    return {
      calendarManualInterviewRequests: [CalendarManualInterviewRequestEntity],
      candidate: CandidateEntity,
      opportunity: OpportunityEntity,
      user: UserEntity,
    };
  }
  static override toJSON() {
    return { name: this.name, schema: {}, key: this.key };
  }
  static override process(input: unknown): unknown {
    if (
      input !== null &&
      typeof input === 'object' &&
      'ClientRequest' in input
    ) {
      const { ClientRequest: wrapped, ...rest } = input as {
        ClientRequest: object;
      } & object;
      return { ...(wrapped as object), ...rest };
    }
    return input;
  }
}